import { IDisposable } from '../definition/IDisposable';
import { MiscUtil } from '../utility/MiscUtil';

class CallOnDispose implements IDisposable {
  private callOnDispose: () => void;

  public constructor(callOnDispose: () => void) {
    this.callOnDispose = callOnDispose;
  }

  public dispose(): void {
    if (MiscUtil.IsNullOrUndefined(this.callOnDispose)) {
      return;
    }
    this.callOnDispose();
    this.callOnDispose = null;
  }
}

class DisposableHolder implements IDisposable {
  private disposables: IDisposable[] = [];

  public add(ds: {}): void {
    if (typeof ds === 'function') {
      this.disposables.push(new CallOnDispose(ds as () => void));
    } else if ((ds as IDisposable).dispose !== undefined) {
      this.disposables.push(ds as IDisposable);
    } else if (!MiscUtil.IsNullOrUndefined(ds as IDisposable[])) {
      (ds as IDisposable[]).forEach(disposable => {
        this.disposables.push(disposable);
      });
    }
  }

  public dispose(): void {
    this.disposables.forEach(disposable => {
      disposable.dispose();
    });
    this.disposables = [];
  }
}

export { DisposableHolder, CallOnDispose };
